import dynamic from 'next/dynamic';

import {
  Button,
  Container,
  Htag,
  HtagColor,
  HtagVariant,
  Notification,
  PostPreviewList,
  TabsList,
  WorksCardList,
} from '../../components';
import { WorksCardProps } from '../../components/works-card';
import tabs from '../../utils/tabs';
import { IArticles } from '../blog/blog.types';
import MVPIntro from '../mvp/mvp-intro';
import styles from './home.module.css';

const DynamicWorkCard = dynamic(() => import('../../components/works-card'), {
  ssr: true,
});

const DynamicCommentsList = dynamic(
  () => import('../../components/comments-list'),
  {
    ssr: true,
  },
);

export interface HomePageProps extends Record<string, unknown> {
  posts: IArticles;
  works: Array<WorksCardProps>;
}

function HomePage({ posts, works }: HomePageProps) {
  return (
    <div className={styles.page}>
      {/* <section className={styles.intro}>
        <Container>
          <div className={styles.intro_inner}>
            <h1 className={styles.intro_title}>
              We are Web and Mobile experts
            </h1>
          </div>
          <div className={styles.devided} />
        </Container>
      </section> */}
      <MVPIntro buttonText="Learn More" buttonLink="/mvp" />
      <section className={styles.works}>
        <Container>
          <div className={styles.works_inner}>
            <Htag
              tag="h2"
              color={HtagColor.light}
              className={styles.works_title}
              variant={HtagVariant.h2}
            >
              OUR WORKS
            </Htag>
            <div id="works">
              <WorksCardList className={styles.works_list}>
                {works.map((work, index) => (
                  <DynamicWorkCard key={index} {...work} />
                ))}
              </WorksCardList>
            </div>
          </div>
          <div className={styles.works_all}>
            <Button tag="a" href="/works" appearance="primary">
              See all projects
            </Button>
          </div>
        </Container>
      </section>

      <section className={styles.tabs} id="services">
        <Container>
          <Htag
            tag="h2"
            color={HtagColor.light}
            className={styles.tabs_title}
            variant={HtagVariant.h2}
          >
            our process
          </Htag>
          <TabsList tabs={tabs} />
        </Container>
      </section>

      <Container>
        <section className={styles.clients}>
          <h2 className={styles.works_title}>Reviews from our clients</h2>
          <DynamicCommentsList className={styles.comments} />
        </section>
        <Notification
          title="HAVE A PROJECT IN MIND?"
          buttonName="Contact us"
          href="/contact"
          className={styles.notification}
        />
      </Container>

      <section>
        <Container>
          <PostPreviewList posts={posts} />
          <div className={styles.works_all}>
            <Button tag="a" href="/blog" appearance="primary">
              See all
            </Button>
          </div>
        </Container>
      </section>
    </div>
  );
}

export default HomePage;
